module.exports = __webpack_public_path__ + "images/bertjonk_small3d454e1c0bb6efc50a78cb012986d2f8.png";